<template>
    <picture v-if="image">
        <source
            type="image/webp"
            :srcset="`${image?.sizes?.placeholder ? image.sizes.placeholder : image?.sizes?.medium}.webp`"
            :data-srcset="`${image?.sizes?.largeRetina ? image.sizes.largeRetina : image.url}.webp 1440w,
             ${image.sizes.large}.webp 1024w,
             ${image.sizes.medium_large}.webp 600w,
             ${image.sizes.medium}.webp 320w`">
        <source
            :type="image.mime_type"
            :srcset="`${image.sizes?.placeholder ? image.sizes.placeholder : image.sizes.medium}`"
            :data-srcset="`${image?.sizes?.largeRetina ? image.sizes.largeRetina : image.url} 1440w,
             ${image.sizes.large} 1024w,
             ${image.sizes.medium_large} 600w,
             ${image.sizes.medium} 320w`">
        <img class="lazyload blur-up" :class="classImg" data-expand="-50" width="400" height="300" loading="lazy" :data-src="image.url" :alt="image.alt || placeholder">
    </picture>
</template>

<script>
export default {
    name: "imageSrcset",
    props: ['imageVar', 'imageClass'],
    data: function () {
        return {
            image: this.imageVar,
            classImg: this.imageClass,
            placeholder: 'Placeholder'
        }
    },
}
</script>

<style scoped>

</style>